module.exports = __webpack_public_path__ + "img/my-nfts-icon.ea8d0721.svg";